import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=5c8ce3b6&scoped=true"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"
import style0 from "./Index.vue?vue&type=style&index=0&id=5c8ce3b6&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c8ce3b6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yogeshadhikari/Desktop/Projects/Scopic/picflow/picflow-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5c8ce3b6')) {
      api.createRecord('5c8ce3b6', component.options)
    } else {
      api.reload('5c8ce3b6', component.options)
    }
    module.hot.accept("./Index.vue?vue&type=template&id=5c8ce3b6&scoped=true", function () {
      api.rerender('5c8ce3b6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/templates/editor/Index.vue"
export default component.exports